import React from "react";
import styles from "./CatalogManagement.module.scss";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import Item from "../../../../shared/item/Item";
import { Table, TableHead } from "@material-ui/core";
import {
  CheckBoxTableCellHeader,
  NonEditTableHeader,
  SpecsTableHeaderPricingDetails,
  WarningTableCell,
} from "../../../../shared/pricing/dealerFees/TableComponents";
import SortingIcon from "../../../../shared/sortingIcon/SortingIcon";

const CatalogHeader = (props) => {
  const headers = [
    {
      id: "market",
      key: "market",
      translation: "MARKET",
      sorting: false,
    },
    {
      id: "model",
      key: "model",
      translation: "MODEL",
      sorting: false,
    },
    {
      id: "year",
      key: "year",
      translation: "YEAR",
      sorting: false,
    },
  ];

  function tableHeader(header) {
    return (
      <NonEditTableHeader id={header.id} className={styles.vehiclesShadowRow}>
        <div
          className={`${styles.vehiclesHeaderWrap} ${styles.vehiclesHeader}`}
        >
          <Item value={header.translation} />
          <span className={styles.sorting}>
            {header.sorting && (
              <SortingIcon
                currentKey={header.key}
                sortKey={props.sortKey}
                sortDirection={props.sortDirection}
              />
            )}
          </span>
        </div>
      </NonEditTableHeader>
    );
  }

  return (
    <div className={styles.rowBorder}>
      <Table>
        <TableHead>
          <tr key="some hea">
            <WarningTableCell />
            <CheckBoxTableCellHeader className={styles.rowItem}>
              <CheckBox
                className="toggleAllCheckbox"
                id="toggleAllCheckbox"
                key="toggleAllCheckbox"
                checked={true}
                isDisabled={true}
              />
            </CheckBoxTableCellHeader>
            {headers.map((header) => {
              return tableHeader(header);
            })}
            <SpecsTableHeaderPricingDetails
              id="catalogId"
              key="catalogId"
              className={`${styles.vehiclesShadowRow} ${styles.width15cent}`}
            >
              <div
                className={`${styles.vehiclesHeaderWrap} ${styles.vehiclesHeader}`}
              >
                <Item value="CATALOG ID" />
              </div>
            </SpecsTableHeaderPricingDetails>
            <NonEditTableHeader
              className={`${styles.vehiclesShadowRow} ${styles.actionsHeader}`}
            >
              <div
                className={`${styles.vehiclesHeaderWrap} ${styles.vehiclesHeader}`}
              >
                <Item className={styles.actionPadding} value="ACTION" />
              </div>
            </NonEditTableHeader>
          </tr>
        </TableHead>
      </Table>
    </div>
  );
};

export default CatalogHeader;
